
import { FileText } from "lucide-react";
import { ChangelogSubscribe } from "../changelog/ChangelogSubscribe";

type Changelog = {
  id: string;
  title: string;
  description: string;
  type: 'feature' | 'bugfix' | 'improvement';
  created_at: string;
};

type PublicChangelogListProps = {
  changelogs: Changelog[];
  companyId: string;
  companyName: string;
  isPro?: boolean;
};

export const PublicChangelogList = ({ 
  changelogs,
  companyId,
  companyName,
  isPro = false,
}: PublicChangelogListProps) => {
  return (
    <div className="space-y-6">
      <div className="mb-8">
        <ChangelogSubscribe 
          companyId={companyId}
          companyName={companyName}
        />
      </div>
      <div className="space-y-4">
        {changelogs.map((changelog) => (
          <div
            key={changelog.id}
            className="p-4 border rounded-lg space-y-2"
          >
            <div className="flex items-center gap-2">
              <FileText className="w-4 h-4" />
              <h3 className="font-medium">{changelog.title}</h3>
            </div>
            <div 
              className="prose prose-sm text-muted-foreground"
              dangerouslySetInnerHTML={{ __html: changelog.description }}
            />
            <div className="flex items-center gap-2">
              <span className="text-xs text-muted-foreground">
                {new Date(changelog.created_at).toLocaleDateString()}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
